"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var EditorExtractTextDialog_1 = __importDefault(require("../../components/EditorExtractTextDialog"));
var ExtractTextFromImageDialogContainer = function (_a) {
    var file = _a.file, open = _a.open, onClose = _a.onClose, RichTextEditorProps = _a.RichTextEditorProps;
    var _b = core_1.useFirebase(), functions = _b.functions, storage = _b.storage;
    var editor = slate_react_1.useEditor();
    var _c = __read(react_1.useState('uploading'), 2), status = _c[0], setStatus = _c[1];
    var _d = __read(react_1.useState(), 2), extractedValue = _d[0], setExtractedValue = _d[1];
    var _e = __read(react_1.useState([]), 2), value = _e[0], setValue = _e[1];
    var _f = __read(react_1.useState(''), 2), src = _f[0], setSrc = _f[1];
    var _g = __read(react_1.useState(new FileReader()), 1), reader = _g[0];
    var _h = __read(react_1.useState(new Image()), 1), image = _h[0];
    var _j = __read(react_1.useState(''), 2), error = _j[0], setError = _j[1];
    // Initialize reactivateSubscription Firebase function
    var extractTextFromImage = functions.httpsCallable('extractTextFromImage');
    function onUploadSuccess(url, id) {
        return __awaiter(this, void 0, void 0, function () {
            var result, annotation, document_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setStatus('analyzing');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, extractTextFromImage({ fileName: id })];
                    case 2:
                        result = _a.sent();
                        annotation = result.data[0].fullTextAnnotation;
                        if (annotation) {
                            document_1 = [];
                            // pages > blocks > paragraphs > words > symbols > text
                            annotation.pages.forEach(function (page) {
                                page.blocks.forEach(function (block) {
                                    block.paragraphs.forEach(function (paragraph) {
                                        var paragraphText = '';
                                        paragraph.words.forEach(function (word, index) {
                                            var wordText = index === 0 ? '' : ' ';
                                            word.symbols.forEach(function (symbol) {
                                                wordText += symbol.text;
                                            });
                                            paragraphText += wordText;
                                        });
                                        document_1.push({
                                            type: 'paragraph',
                                            children: [{ text: paragraphText }],
                                        });
                                    });
                                });
                            });
                            setStatus('ready');
                            setExtractedValue(document_1);
                        }
                        else {
                            setExtractedValue(core_1.createEmptyDocument());
                            setStatus('no-text');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setStatus('error');
                        setError(err_1.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var _k = core_1.useFileUpload(storage, { onUploadSuccess: onUploadSuccess }), upload = _k.upload, progress = _k.progress, uploadedFileId = _k.id, uploadedFileUrl = _k.url;
    reader.onload = function (event) {
        setSrc(event.target.result);
    };
    react_1.useEffect(function () {
        if (file) {
            upload(file);
            reader.readAsDataURL(file);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file]);
    react_1.useEffect(function () {
        if (typeof src === 'string') {
            image.src = src;
        }
    }, [image.src, src]);
    function insertText() {
        value.forEach(function (block) {
            slate_1.Transforms.insertNodes(editor, block);
        });
        onClose();
    }
    function insertImage() {
        slate_1.Transforms.insertNodes(editor, {
            type: 'image-uploaded',
            cropped: false,
            id: uploadedFileId,
            url: uploadedFileUrl,
            children: [{ text: '' }],
            dimensions: {
                height: image.height,
                width: image.width,
                aspectRatio: image.width / image.height || 1,
            },
        });
        onClose();
    }
    return (react_1.default.createElement(EditorExtractTextDialog_1.default, { open: open, onClickCancel: onClose, onClickInsertText: insertText, onClickInsertImage: insertImage, src: src, status: status, error: error, uploadProgress: progress, editorValue: extractedValue, RichTextEditorProps: __assign(__assign({}, RichTextEditorProps), { initialValue: core_1.createEmptyDocument(), onChange: setValue, toolbar: [
                'bold',
                'underline',
                'italic',
                'strikethrough',
                'tex',
                'block-formatting',
                'numbered-list',
                'bulleted-list',
            ] }) }));
};
exports.default = ExtractTextFromImageDialogContainer;
//# sourceMappingURL=ExtractTextFromImageDialogContainer.js.map